"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileBottomBar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const bottomBarMobile_module_scss_1 = __importDefault(require("./bottomBarMobile.module.scss"));
const FilterContext_1 = require("../../../context/filters/FilterContext");
const filtersHelpers_1 = require("../../../common/utils/filtersHelpers");
const react_i18next_1 = require("react-i18next");
const MobileBottomBar = ({ username, avatarUrl, homeRoute, profileRoute, }) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const isInvoiceRoute = location.pathname.startsWith('/invoices');
    const { setFilters } = (0, FilterContext_1.useFilters)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const isActive = (path) => location.pathname === path;
    const handleNavigate = (route) => {
        localStorage.removeItem('filters');
        setFilters((0, filtersHelpers_1.getInitialFilters)());
        navigate(route);
    };
    const navItems = [
        {
            icon: 'pi pi-home',
            label: t('home') || 'Home',
            route: homeRoute,
        },
        {
            icon: 'pi pi-user',
            label: t('profile') || 'Profile',
            route: profileRoute,
        },
    ];
    return ((0, jsx_runtime_1.jsx)("nav", { className: bottomBarMobile_module_scss_1.default.container, children: !isInvoiceRoute &&
            navItems.map((item) => {
                const active = isActive(item.route);
                return ((0, jsx_runtime_1.jsxs)("div", { className: `${bottomBarMobile_module_scss_1.default.navItem} ${active ? bottomBarMobile_module_scss_1.default.navItemActive : ''}`, onClick: () => handleNavigate(item.route), role: "button", tabIndex: 0, "aria-label": item.label, children: [(0, jsx_runtime_1.jsx)("i", { className: `${item.icon} ${bottomBarMobile_module_scss_1.default.navIcon}` }), (0, jsx_runtime_1.jsx)("span", { className: bottomBarMobile_module_scss_1.default.navLabel, children: item.label }), active && (0, jsx_runtime_1.jsx)("div", { className: bottomBarMobile_module_scss_1.default.activeIndicator })] }, item.route));
            }) }));
};
exports.MobileBottomBar = MobileBottomBar;
